<template>
  <div class="container">
    <v-content>
      <div class="cms-page">
        <h1>{{ $t('where_found.title') }}</h1>
        <div
          v-for="kiosk in kiosks"
          :key="kiosk.position"
          class="kiosk kiosk--even kiosk--first"
        >
          <img class="kiosk__photo" :src="kiosk.image_url" :alt="kiosk.name" />
          <div class="kiosk__body">
            <h3 class="kiosk__name">
              {{ kiosk.name }}
              <small>{{ kiosk.city }}</small>
            </h3>
            <address>
              {{ kiosk.address1 }}, {{ kiosk.address2 }} - {{ kiosk.address4
              }}<br />
              {{ kiosk.city }}, {{ kiosk.zipcode }}<br />
              ({{ kiosk.address3 }})
            </address>
            <div class="share-btns kiosk__contact">
              <a
                class="share-btns__btn"
                target="_blank"
                :href="`https://api.whatsapp.com/send?phone=${phoneFormatter(
                  kiosk.phone
                )}`"
              >
                <div class="share-btns__item--whatsapp">
                  <whatsapp-icon color="#fff" second-color="#4dc247" />
                </div>
                <div>
                  <p>Fale Conosco</p>
                </div>
              </a>
            </div>
            <div class="kiosk__arrow"></div>
          </div>
        </div>
      </div>
    </v-content>
  </div>
</template>

<script>
import VContent from '~/components/shared/v-content/VContent.vue'
import WhatsappIcon from '~/components/icons/social/whatsapp/Whatsapp'

export default {
  name: 'OndeEncontrarPage',
  components: {
    VContent,
    WhatsappIcon,
  },
  async asyncData({ $axios, store, $sentry, error }) {
    try {
      const { kiosks } = await $axios.$get('kiosks', {
        params: {
          ...store.getters.storeInfo,
        },
      })
      return {
        kiosks,
      }
    } catch (err) {
      error({
        statusCode: err?.response?.status || 404,
        message: 'Page not found',
      })

      return {
        kiosks: [],
      }
    }
  },
  methods: {
    phoneFormatter(phone) {
      const filterJustNumbers = phone.replace(/[^0-9]/g, '')
      const countryCodeAdaptation = filterJustNumbers.startsWith('55')
        ? filterJustNumbers
        : `55${filterJustNumbers}`
      return countryCodeAdaptation
    },
  },
  head() {
    return {
      title: this.$t('where_found.title'),
    }
  },
}
</script>
<style lang="scss" scoped>
@import '~/assets/css/cms-page.scss';
@import '~/assets/css/variables.scss';
@import '~/assets/css/container.scss';

.kiosk__region {
  font-size: 24px;
  font-weight: normal;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
  margin-bottom: 15px;
  display: none;
}

.kiosk {
  margin-bottom: 25px;

  .kiosk__arrow {
    width: 0;
    height: 0;
    border-top: 25px solid transparent;
    border-bottom: 25px solid transparent;
    border-right: 25px solid white;
    display: none;
  }

  .kiosk__photo {
    display: block;
    max-width: 100%;
  }

  .kiosk__name {
    margin-top: 0;
    text-transform: uppercase;
    font-weight: bold;
    margin-bottom: 8px;

    small {
      display: block;
      font-weight: normal;
    }
  }

  p {
    margin: 5px 0;
  }

  .kiosk__body {
    border-width: 0 1px 1px;
    border-style: solid;
    border-color: #eee;
    padding: 10px 15px;
  }

  .kiosk__info {
    position: relative;
    padding-left: 24px;

    .icon {
      position: absolute;
      top: 3px;
      left: 0;
    }
  }
}
.kiosk__contact {
  font-weight: 600;
  font-size: 18px;
  display: flex;
  justify-content: center;
  background: #4dc247;
  height: 50px;
  min-width: 50px;
  max-width: 200px;
  margin: 20px auto;
  border-radius: 25px;
}
.kiosk__contact a {
  display: flex;
  align-items: center;
}
.kiosk__contact div {
  min-width: max-content;
  font-size: 18px;
  color: #fff;
}
.kiosk__contact div p {
  margin: 0 6px;
  padding-bottom: 2px;
}
.share-btns__btn {
  text-decoration: none;

  svg {
    width: 22px;
    color: #4dc247;
  }
}

@media (min-width: $screen_large) {
  .kiosk__region {
    font-size: 30px;
    margin-bottom: 0;
    text-align: center;
    margin-top: 20px;
    padding-bottom: 10px;
  }

  .kiosk {
    position: relative;
    margin-bottom: 15px;
    font-size: 16px;
    line-height: 1.4;
    margin-bottom: -5px;

    &.kiosk--first {
      margin-top: 35px;
    }

    .kiosk__arrow {
      display: block;
      position: absolute;
      top: 50%;
      margin-top: -25px;
      left: -25px;
    }

    p {
      margin: 15px 0;
    }

    .kiosk__name {
      font-size: 22px;
    }

    &.kiosk--odd {
      text-align: right;

      .kiosk__arrow {
        left: auto;
        right: -25px;
        border-left: 25px solid white;
        border-right: 0;
      }

      .kiosk__body {
        left: 0;
        right: 50%;
        padding-left: 0;
        padding-right: 50px;
      }
    }

    .kiosk__icon {
      padding: 0;

      .icon {
        display: none;
      }
    }

    .kiosk__photo {
      width: 50%;
      height: auto;
      display: inline-block;
    }

    .kiosk__body {
      border: 0;
      padding: 15px 0 0 50px;
      position: absolute;
      right: 0;
      left: 50%;
      text-align: center;
      top: 50%;
      margin-top: -102px;
    }
  }
}

@media (min-width: $screen_larger) {
  .kiosk .kiosk__body {
    margin-top: -105px;
  }
}
</style>
